<template>
    <div class="w-full" v-if="visible">
        <template v-if="editMode">
            <div class="flex text-gray-600 text-sm px-4 items-start">
                <div class="pr-4 flex-grow-4">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">Beschreibung</label>
                    <input type="text" class="input w-full" v-model="invoiceItem.description"
                           placeholder="Beschreibung"/>
                    <div class="input-error-message" v-if="errors['description']">{{errors['description'][0]}}</div>
                    <div class="mt-1">
                      <input type="checkbox" v-model="invoiceItem.is_refund"> Auslage
                    </div>
                </div>
                <div class="pr-4 flex-grow-2">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">Netto-Betrag</label>
                    <currency-input
                            v-model="invoiceItem.amount"
                            currency="EUR"
                            locale="de"
                            class="input w-full"
                    />
                    <div class="input-error-message" v-if="errors['jurisdictional_amount']">
                        {{errors['jurisdictional_amount'][0]}}
                    </div>
                </div>
                <div class="pr-4 flex-grow-1">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">UST %</label>
                    <input type="text" class="input w-full" v-model="invoiceItem.sales_tax_percent"
                           placeholder="USt"/>
                    <div class="input-error-message" v-if="errors['sales_tax_percent']">
                        {{errors['sales_tax_percent'][0]}}
                    </div>
                </div>
                <button v-on:click="save()" class="btn btn-small btn-secondary ml-2 mt-8"><i
                        class="far fa-plus-square"></i> speichern
                </button>
                <button v-on:click="abort()" class="btn btn-small btn-secondary ml-2 mt-8"><i
                        class="far fa-plus-square"></i> abbrechen
                </button>
            </div>
        </template>
        <template v-else>
            <invoice-item
                    v-if="!invoiceItem.hidden"
                    @edit="edit()"
                    @delete="destroy()"
                    :key="invoiceItem.id"
                    :description="invoiceItem.description"
                    :factor="invoiceItem.factor"
                    :jurisdictional_amount="invoiceItem.jurisdictional_amount"
                    :amount="invoiceItem.amount"
                    :sales_tax_percent="invoiceItem.sales_tax_percent"
                    :is_refund="invoiceItem.is_refund"
            >
            </invoice-item>
            <template v-else>
                <div class="px-4 text-gray-600">
                    {{ invoiceItem.description }}
                    <button v-on:click="edit()" class="btn btn-small btn-secondary ml-2"><i
                            class="far fa-plus-square"></i> hinzufügen
                    </button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        components: {},
        props: [
            'initialItem',
            'fixedFields',
        ],
        data() {
            return {
                invoiceItem: JSON.parse(JSON.stringify(this.initialItem)),
                editMode: false,
                errors: [],
                visible: true,
            }
        },
        methods: {
            save: function () {
                if (this.invoiceItem.new_record) {
                    this.createItem();
                } else {
                    this.updateItem();
                }
            },
            edit: function () {
                this.editMode = true
                if (this.invoiceItem.sales_tax_percent == null) {
                    this.invoiceItem.sales_tax_percent = 19
                }
                this.$forceUpdate()
            },
            destroy: function () {
                if (this.invoiceItem.identifier) {
                    this.resetItem();
                } else {
                    this.deleteItem();
                }
            },
            abort: function () {
                if (this.invoiceItem.new_record) {
                    this.$emit('item-removed');
                } else {
                    this.invoiceItem.description = this.initialItem.description
                    this.invoiceItem.amount = this.initialItem.amount
                    this.invoiceItem.sales_tax_percent = this.initialItem.sales_tax_percent
                    this.editMode = false
                }
                this.$forceUpdate()
            },
            updateItem: function () {
                this.$http['put']('/invoice_free_items/' + this.invoiceItem.id, {
                    invoice_free_item: {
                        hidden: false,
                        factor: this.invoiceItem.factor,
                        description: this.invoiceItem.description,
                        amount: this.invoiceItem.amount,
                        sales_tax_percent: this.invoiceItem.sales_tax_percent,
                        is_refund: this.invoiceItem.is_refund,
                    }
                }).then(response => {
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    this.$forceUpdate()
                }, response => {
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            },
            createItem: function () {
                this.$http['post']('/invoice_free_items/', {
                    invoice_free_item: {
                        hidden: false,
                        invoice_id: this.invoiceItem.invoice_id,
                        factor: this.invoiceItem.factor,
                        description: this.invoiceItem.description,
                        amount: this.invoiceItem.amount,
                        sales_tax_percent: this.invoiceItem.sales_tax_percent,
                        section: this.invoiceItem.section,
                        is_refund: this.invoiceItem.is_refund,
                    }
                }).then(response => {
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    console.log('item added')
                    this.$emit("item-created")
                    this.$forceUpdate()
                }, response => {
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            },
            deleteItem: function () {
                this.$http['delete']('/invoice_free_items/' + this.invoiceItem.id).then(response => {
                    console.log(response.body)
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    this.$emit("item-removed", this.invoiceItem)
                    this.$forceUpdate()
                }, response => {
                    // console.log(response)
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            },
            resetItem: function () {
                this.$http['delete']('/invoice_free_items/' + this.invoiceItem.id + '/reset').then(response => {
                    console.log(response.body)
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    this.$forceUpdate()
                }, response => {
                    // console.log(response)
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            }
        },
        mounted: function () {
            if (this.invoiceItem.new_record) {
                this.edit()
            }
        }
    }
</script>